<template>
    <div class="editable-settings__input-wrapper">
        <slot name="label" />
        <Input
            ref="inputEl"
            :model-value="modelValue"
            type="text"
            class="editable-settings__input"
            size="small"
            :class="{ 'editable-settings__input--with-suffix': showSuffix }"
            :placeholder="placeholder"
            @onChange="onChange"
        >
            <template #append>
                <span v-show="showSuffix">{{ suffix }}</span>
            </template>
        </Input>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "EditableSettingsTextInput",

    props: {
        modelValue: {
            type: String,
            default: undefined
        },
        placeholder: {
            type: String
        },
        suffix: {
            type: String,
            default: "px"
        },
        showSuffix: {
            type: Boolean,
            default: false
        }
    },

    emits: ["update:modelValue"],

    methods: {
        onChange(event: InputEvent) {
            const value = (event.target as HTMLInputElement).value;

            this.$emit("update:modelValue", value);
        }
    }
});
</script>
